
import PreHead from '~/components/ui/PreHead.vue'
export default {
  props: {
    management: {
      type: Array,
      required: true
    }
  },
  data() {
    return {
      animationClass: '',
      intersectionOptions: {
        root: null,
        rootMargin: '0px 0px 0px 0px',
        threshold: [0.6, 0.75]
      }
    }
  },
  components: {
    PreHead
  },
  methods: {
    onSetAnimationClass({ going }) {
      if (going === this.$waypointMap.GOING_IN) {
        this.animationClass = 'animate__animated animate__shiftLeft'
      }
    }
  }
}
